import React, { useRef } from 'react';

import { StyleSheet } from 'react-native';
import Svg, { Defs, Rect, Stop, RadialGradient as SvgRadialGradient } from 'react-native-svg';

export type RadialGradientConfig = {
  center?: { x: number; y: number };
  radius?: { x: number; y: number };
  stops: {
    color: string;
    offset: number;
    opacity?: number;
  }[];
};

export const ActionButtonRadialGradient = ({ config }: { config: RadialGradientConfig }) => {
  const gradientIdRef = useRef(`primary-takeover-gradient-${Math.random().toString(36).slice(2)}`);

  const centerX = config.center?.x ?? 0.5;
  const centerY = config.center?.y ?? 0.5;
  const radiusX = config.radius?.x ?? 1;
  const radiusY = config.radius?.y ?? radiusX;

  return (
    // @ts-ignore - style type mismatch on web
    <Svg pointerEvents="none" style={styles.takeoverGradientOverlay}>
      {/* @ts-ignore - Defs children not typed for web */}
      <Defs>
        <SvgRadialGradient
          id={gradientIdRef.current}
          cx={centerX}
          cy={centerY}
          fx={centerX}
          fy={centerY}
          rx={radiusX}
          ry={radiusY}
        >
          {config.stops.map((stop, index) => (
            <Stop
              key={`${stop.color}-${index}`}
              offset={stop.offset}
              stopColor={stop.color}
              stopOpacity={stop.opacity ?? 1}
            />
          ))}
        </SvgRadialGradient>
      </Defs>
      <Rect fill={`url(#${gradientIdRef.current})`} width="100%" height="100%" />
    </Svg>
  );
};
const styles = StyleSheet.create({
  takeoverGradientOverlay: {
    ...StyleSheet.absoluteFillObject,
  },
});
